import CompaniesApi from "../../apis/Companies";
import CustomersApi from "../../apis/Customers";

export default {
  namespaced: true,
  state: {
    companies: [],
    company: null,
    paginated:{}
  },
  mutations: {
    set_companies(state, companies) {
      state.companies = companies;
    },
    set_company(state, data) {
      state.company = data;
    },
    set_paginated (state, data) {
      state.paginated =  data
  }
  },
  actions: {
    setCompanies({ commit }, companies) {
      commit("set_companies", companies);
    },
    async getCompanies({ commit }, filters = null) {
      return await CompaniesApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
          })
          commit("set_companies", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          console.log(error);
        });
    },
    async store({ dispatch }, company) {
      return await CompaniesApi.store(company)
        .then((response) => {
          dispatch("getCompanies");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("sales/select_company", response.data, { root: true });
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al registrar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    emptyCompany({ commit }) {
      commit("set_company", null);
    },
    async searchDocument({ commit, dispatch }, document) {
      return await CustomersApi.search_document(document)
        .then((response) => {
          commit("set_company", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          let message = "No se encontró número de documento";
          if (error.response.data.error_message) {
            message = error.response.data.error_message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, company) {
      return await CompaniesApi.update(company)
        .then((response) => {
          dispatch("getCompanies");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al actualizar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, company) {
      let action = company.active ? "inactivación" : "activación";
      return await CompaniesApi.change_status(company)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCompanies");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, company) {
      return await CompaniesApi.delete(company)
        .then((response) => {
          dispatch("getCompanies");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async upload({ dispatch }, company) {
      return await CompaniesApi.upload(company)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message:
                "Los reactivos del archivo se registraron de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCompanies");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null;
          let message =
            "Ocurrió un error al registrar productos del archivo, vuelva a intentarlo.";
          if (error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
  },
};
